(ns arthur.events.paint
  "Polygon edits. Every one of them is `edit/edit` plus a pure `domain/paint`
  function, which is the shape every document edit in this app should have."
  (:require [arthur.domain.paint :as paint]
            [arthur.events.edit :as edit]
            [re-frame.core :as rf]))

(rf/reg-event-db
 ::new-shape
 ;; `frame` is the symbol's own: a shape drawn into an instance starts on the
 ;; frame that instance is showing, not the transport's.
 (fn [db [_ sid id frame points color]]
   (edit/edit db #(paint/new-shape % sid id frame points color))))

(rf/reg-event-db
 ::add-key
 ;; `frame` is the shape's own, which is the transport's only for a shape in the
 ;; open symbol with no time map of its own.
 (fn [db [_ sid id frame]]
   (edit/edit db #(paint/add-key % sid id frame))))

(rf/reg-event-db
 ::set-vertex
 (fn [db [_ sid id key-frame vertex point]]
   (edit/edit db #(paint/set-vertex % sid id key-frame vertex point))))
